import { Pipe, PipeTransform } from "@angular/core";
import { NotificationType } from "../models/notification-type.enum";
import { NotificationPriority } from "../models/notification-priority.enum";

@Pipe({
    name: "notificationTypeIconBackgroundPipe"
})
export class NotificationTypeIconBackgroundPipe implements PipeTransform {
    transform(priority: NotificationPriority): string {
        switch (priority) {
            case NotificationPriority.CRITICAL:
                return "has-background-danger";
            case NotificationPriority.IMPORTANT:
                return "has-background-warning";
            case NotificationPriority.INFO:
                return "has-background-primary";
            default:
                return "has-background-info";
        }
    }
}